module.exports = __webpack_public_path__ + "img/20200513_145949.2c1739f9.jpg";